// extracted by mini-css-extract-plugin
export default {"wrapper":"cv1l3pCzk_DBeYIdHDQa","header":"r2ybcgiNu9SLBbaIh425","title":"lMfoARTn54Fv3PItnekN","secondTitle":"S0qZaNo759jJEW8ab6iT"};